import React, { useEffect, useState } from 'react';
import {
    useSsSelector as useSelector,
} from '~SpectateStore';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import {
    selectShowContingenciesNotification,
} from '~Betslip/selectors/contingenciesSelectors';

import {
    selectShowPriceChangeNotification,
} from '~Betslip/selectors/notificationSelectors';

import {
    selectAnySelectionSuspended,
} from '~Betslip/selectors/selectionDetailsSelectors';

import {
    selectAnySelectionReverseCast,
} from '~Betslip/selectors/userSelectionsSelectors';

import {
    selectDisplayFullslip,
} from '~Betslip/selectors/uiSelectors';

import './styles.scss';

import {
    selectShowDepositNotification,
} from '~Betslip/selectors/userSelectors';

import {
    selectIsMultiCastMarket,
} from '~Betslip/selectors/userMultiplesSelectors';

import {
    useIsUserLoggedIn,
} from '~SpectateStore/hooks/userHooks';

import {
    useNotificationHideDelayConfig,
} from '~SpectateStore/hooks/clientStateHooks';

const Notifications = () => {
    const [ t ] = useTranslation();
    const showContingenciesNotification = useSelector(selectShowContingenciesNotification);
    const showPriceChangeNotification = useSelector(selectShowPriceChangeNotification);
    const showSuspendedNotification = useSelector(selectAnySelectionSuspended);
    const showDepositNotification = useSelector(selectShowDepositNotification);
    const isMultiCastMarket = useSelector(selectIsMultiCastMarket);
    const isReverseCastMarket = useSelector(selectAnySelectionReverseCast);
    const showReverseCastNotification = isMultiCastMarket || isReverseCastMarket;
    const isUserLoggedIn = useIsUserLoggedIn();
    const displayFullslip = useSelector(selectDisplayFullslip);
    const notificationHideDelay = useNotificationHideDelayConfig();

    const [hideNotification, setHideNotification] = useState(null);

    useEffect(() => {
        let timer;

        if (showPriceChangeNotification && !displayFullslip) {
            timer = setTimeout(() => setHideNotification(true), notificationHideDelay);
        }

        return () => timer && clearTimeout(timer);
    }, [showPriceChangeNotification]);

    const notification = (type, text) => {
        const betslipModeClass = displayFullslip ? 'fullslip' : 'babyslip';
        const classes = classNames(
            `${betslipModeClass}__notification`,
            `${betslipModeClass}__notification--${type}`,
        );

        return (
            <p
                className={classes}
                data-test-id={`betslip;notification-${type}`}
            >
                {text}
            </p>
        );
    };

    const renderContingenciesNotification = () => {
        if (!showContingenciesNotification) {
            return null;
        }

        const text = displayFullslip
        ? t('betslip.contingency')
        : t('betslip.contingency_babyslip');

        return notification(
            'contingency',
            text
        );
    };

    const renderReverseCastNotification = () => {
        if (!showReverseCastNotification || displayFullslip) {
            return null;
        }

        return notification(
            'reverse-cast',
            t('betslip.place_on_fullslip')
        );
    };

    const renderPriceChangeNotification = () => {
        if (!showPriceChangeNotification || hideNotification === true) {
            return null;
        }

        const text = displayFullslip
            ? t('betslip.price_update')
            : t('betslip.odds_have_changed');

        return notification(
            'odds-changed',
            text
        );
    };

    const renderSuspendedNotification = () => {
        if (!showSuspendedNotification) {
            return null;
        }

        const text = displayFullslip
        ? t('betslip.suspended_notification')
        : t('betslip.selections_suspended');

        return notification(
            'suspended',
            text
        );
    };

    const renderDepositNotification = () => {
        if (isUserLoggedIn && showDepositNotification) {

            return notification(
                'deposit',
                t('betslip.deposit_notification')
            );
        }

        return null;
    };

    const renderNotification = () => {
        if (displayFullslip) {
            return (
                <>
                    {renderSuspendedNotification()}
                    {renderPriceChangeNotification()}
                    {renderContingenciesNotification()}
                    {renderReverseCastNotification()}
                    {renderDepositNotification()}
                </>
            );
        }

        const priorities = [
            renderDepositNotification,
            renderContingenciesNotification,
            renderReverseCastNotification,
            renderSuspendedNotification,
            renderPriceChangeNotification,
        ];

        let priorityNotification = null;

        priorities.some((fn) => {
            priorityNotification = fn();

            return Boolean(priorityNotification);
        });

        return priorityNotification;
    };

    return renderNotification();
};

export default Notifications;
